import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import ThreadListMembersSidebarWrapper from '../../thread-list-member-sidebar/components/ThreadListMembersSidebarWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxPreviewCardList = ({
  focusedThreadId
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "InboxPreviewCardList",
    children: /*#__PURE__*/_jsx(ThreadListMembersSidebarWrapper, {
      threadId: focusedThreadId
    })
  });
};
InboxPreviewCardList.displayName = 'InboxPreviewCardList';
export default InboxPreviewCardList;